/* src/app/service/app-loader/app-loader.component.scss */
.mat-dialog-content {
  min-height: 122px;
}
/*# sourceMappingURL=app-loader.component.css.map */
